// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__YZYtZ","inputs":"Stand_inputs__4fOn8","buttons":"Stand_buttons__6XZ8x","checkboxes":"Stand_checkboxes__ok-4B"};